import { Show, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import { Progress } from "../components/progress";
import { CMS } from "../components/cms/cms";
import { loadCms } from "../app";
import { Img } from "../components/universal/image";
import { A, useRouteData } from "@solidjs/router";
import { PageLoading } from "../components/page-loading";

type State = {
    isCMSReady: boolean;
}
type Model = {
    amountOwing: number;
    applicationStatus: string;
}

export function Step3() {
    const [state, setState] = createStore<State>({ isCMSReady: false });
    const [model, setModel] = createStore<Model>({ amountOwing: 0, applicationStatus: "" });
    const hasPaid = () => model.applicationStatus === "Paid" || model.applicationStatus === "Reviewing";
    onMount(async () => {
        const routeData = await useRouteData() as any;
        setModel(routeData.model);
        await loadCms([
            "living-artist-application/step-3::introduction",
            "living-artist-application/step-3::application-fee",
            "living-artist-application/step-3::payment-method",
            "label::or"
        ]);
        setState({ isCMSReady: true });
    })
    return (
    <>
        <Show when={state.isCMSReady} fallback={<PageLoading />}>
            <div>
                <Progress step={3}></Progress>
                <Show when={hasPaid()}>
                    <div style="text-align: center; font-family: 'Raleway-Regular';">
                        <h2 class="m-t-xxl" style="font-size: 3em; font-family: 'Oswald';">
                            <CMS id="living-artist-application/step-3::introduction">Your application has been submitted</CMS>
                        </h2>
                        <div style="font-size: 2em; margin: 60px 0;">
                            <p>
                                You have paid the USD <b>{model.amountOwing}</b> application fee
                            </p>
                        </div>
                    </div>
                </Show>
                <Show when={!hasPaid()}>
                    <div style="text-align: center; font-family: 'Raleway-Regular';">
                        <h2 class="m-t-xxl" style="font-size: 3em; font-family: 'Oswald';">
                            <CMS id="living-artist-application/step-3::introduction">Your application is now ready to be submitted</CMS>
                        </h2>
                        <div style="font-size: 2em; margin: 60px 0;">
                            <p>
                                USD <b>{model.amountOwing}</b> application fee
                            </p>
                        </div>
                        {/* <p style="font-size: 1.5em; margin-top: 40px;">
                            <CMS id="living-artist-application/step-3::payment-method">Please choose between <b>credit card</b> or <b>Paypal</b> as the desired form of payment to submit your school's application.</CMS>
                        </p> */}
                        <div style="margin-top: 40px;">
                            <div style="display: inline-block;">
                                <A href="/credit-card" class="btn btn-primary" style="font-size: 2rem;">
                                    Pay Now
                                </A>
                            </div>
                            {/* <div style="display: inline-block; margin: 0 40px; top: 20px;">
                                <span style="font-family: 'Oswald'; font-size: 3em;">
                                    <CMS id="label::or">OR</CMS>
                                </span>
                            </div>
                            <div style="display: inline-block;">
                                <A href="/paypal">
                                    <Img src="/Images/icons/paypal-icon.png" style="height: 100px; width: auto;" />
                                </A>
                            </div> */}
                        </div>
                    </div>
                </Show>                
            </div>
        </Show>
    </>);
}